import React, { ReactNode, useCallback } from "react";

import { useTranslation } from "react-i18next";
import { Badge } from "reactstrap";

import { useAppState } from "../../../context/StateContext";
import { WarehousingTabs } from "../../../util/enums";
import { WarehouseSelect } from "../../WarehouseSelect";
import useStyles, { Wrapper } from "./styles";
import { RolePermissionsResponse } from "Models/resources";

type Props = {
  children?: ReactNode;
  title?: string;
  showWarehouseSelect?: boolean;
  showCompanyVersion?: boolean;
  warehousesToView?: RolePermissionsResponse[];
};

const SubHeader = (props: Props) => {
  const { children, title, showCompanyVersion, showWarehouseSelect, warehousesToView } = props;

  const classes = useStyles();

  const { currentUser } = useAppState();
  const { t: translate } = useTranslation();

  const renderTitle = useCallback(() => {
    if (title) return <span className={classes.title}>{title}</span>;

    return null;
  }, [title, classes]);

  const renderCompanyVersion = useCallback(() => {
    if (currentUser && currentUser?.company && showCompanyVersion) {
      return (
        <div>
          <Badge className={classes.settingsHeaderBadge}>
            {`${currentUser?.company.status} `}
            {translate("company")}
          </Badge>
          <span className={classes.settingsHeaderVersion}>
            {translate("version")} |<strong> {currentUser?.company?.profile?.name}</strong>
          </span>
        </div>
      );
    }

    return null;
  }, [showCompanyVersion, currentUser]);

  const renderRightComponent = useCallback(() => {
    if (showWarehouseSelect) {
      return (
        <Wrapper>
          <WarehouseSelect
            showAllOption={title === WarehousingTabs.TRANSSHIPMENT}
            warehousesToView={warehousesToView}
          />
        </Wrapper>
      );
    }
  }, [title, showWarehouseSelect, warehousesToView]);

  return (
    <header className={classes.subHeader}>
      {renderTitle()}
      {children}
      {renderCompanyVersion()}
      {renderRightComponent()}
    </header>
  );
};

export default SubHeader;
